import {BaseApi} from '@/common/api/BaseApi';

/**
 * Drops every API answer the ApiClient parked in the sessionStorage.
 *
 * client-core clears this cache only in `beforeunload`, which iOS Safari never
 * fires. Without this, a tab keeps the previous account's answers — including
 * `/user-data` — across a logout and the next login (T00N1NIEPQBA).
 */
export function clearApiCache(): void {
  try {
    Object.keys(sessionStorage)
      .filter((key) => key.startsWith(BaseApi.ROOT_URL))
      .forEach((key) => sessionStorage.removeItem(key));
  } catch {
    // storage unavailable → nothing cached either
  }
}
